import script from "./VensoNoticeItemDraft.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoNoticeItemDraft.vue?vue&type=script&setup=true&lang=ts"

import "./VensoNoticeItemDraft.vue?vue&type=style&index=0&id=29c63cd2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29c63cd2"]])

export default __exports__